import { createApp } from 'vue'
import './reset.css'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCircleXmark } from '@fortawesome/free-regular-svg-icons'
import { faLessThan, faGreaterThan } from '@fortawesome/free-solid-svg-icons'
library.add( faCircleXmark, faLessThan, faGreaterThan )


const pinia = createPinia()


createApp(App)
.use(router)
.use(pinia)
.component('font-awesome-icon', FontAwesomeIcon)
.mount('#app')
